import { Alert, AlertIcon, Box, Button, Divider, Flex, Grid, GridItem, Heading, Spacer, Text, Image } from "@chakra-ui/react";
import { FC, ReactElement, useEffect, useState } from "react";
import moment from "moment";
import TimerCountdown from "components/timer-countdown";
import Number from "components/number-format";
import BankAccountService from "services/bankaccounts/bankaccount-service";
import AppConsts from "libs/appconst";

interface CheckoutCompletePaymentStepProps {
    paymentMethod: string;
    order: any;
};

const CheckoutCompletePaymentStep: FC<CheckoutCompletePaymentStepProps> = ({ paymentMethod, order }): ReactElement => {
    const [isLoading, setLoading] = useState<boolean>(true);
    const [bankAccounts, setBankAccounts] = useState<any>([]);

    useEffect(() => {
        setLoading(true);
        BankAccountService.GetMemberBankAccounts().then((resBankAccount: any) => {
            setBankAccounts(resBankAccount.result);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    if (isLoading)
        return <>Loading...</>;

    return (
        <Box mt={{ base: 2, md: 6 }} mb={6} p={{ base: 2, md: 6 }} borderRadius={8} borderStyle={"solid"} borderWidth={{ base: 0, md: 1 }} borderColor={"blackAlpha.300"} textAlign={"center"}>
            <Heading fontSize={{ base: 'md', md: "lg" }}>Segera Selesaikan Pembayaran Anda</Heading>
            <Divider my={4} />
            <Text fontSize={{ base: 'md', md: "lg" }} textAlign={"center"}>Lakukan Transfer sebelum <span color={'teal'}>{moment(order.expiryDate).format("DD MMMM yyyy HH:mm A")}</span></Text>
            <TimerCountdown expiryTimestamp={moment(order.expiryDate)} includeDays={false} />
            <Divider my={4} />
            <Text fontSize={{ base: 'lg', md: "xl" }} textAlign={"center"}>Jumlah yang harus dibayar</Text>
            <Heading fontSize={{ base: '2xl', md: "4xl" }} fontWeight={"bold"} textAlign={"center"} mt={2} color={'teal'}>
                <Number value={order.amount} prefix={'Rp '} />
            </Heading>
            <Flex mt={4}>
                <Spacer />
                <Box >
                    <Alert status='warning' rounded={'lg'} p={{ base: 4, md: 8 }}>
                        <AlertIcon />
                        <Box>
                            <Heading fontSize={{ base: 'sm', md: 'md' }} textAlign={{ base: 'left', md: 'center' }}>Harap transfer sesuai dengan jumlah pembayaran hingga digit terakhir.</Heading>
                            <Text mt={1} fontSize={{ base: 'xs', md: 'md' }} textAlign={{ base: 'left', md: 'center' }}>Jika jumlah yang ditransfer tidak sesuai, proses verifikasi pembayaran anda akan terhambat.</Text>
                        </Box>
                    </Alert>
                </Box>
                <Spacer />
            </Flex>

            <Divider my={4} />
            <Text fontSize={{ base: 'md', md: "lg" }} textAlign={"center"}>Silahkan Transfer ke rekening dibawah ini:</Text>
            <Flex mt={4}>
                <Spacer />
                <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }} gap={6}>
                    {
                        bankAccounts.map((bankAccount: any) => {
                            return (
                                <GridItem>
                                    <Box border={"1px"} rounded={8} px={8} py={4} borderColor={'teal'}>
                                        <Image src={bankAccount.logoUrl} h={"50px"} mb={3} />
                                        <Text align={"center"} fontWeight={"bold"} fontSize={"xl"}>{bankAccount.bankAccountNumber}</Text>
                                        <Text align={"center"} fontSize={"sm"}>Atas Nama</Text>
                                        <Text align={"center"} fontWeight={"bold"}>{bankAccount.bankAccountName}</Text>
                                    </Box>
                                </GridItem>
                            );
                        })
                    }
                </Grid>
                <Spacer />
            </Flex>

            <Divider my={4} />
            <Text fontSize={'sm'} textAlign={"center"}>Kami telah mengirimkan detail transaksi, cara pembayaran dan informasi Akun Anda (jika anda baru pertama kali akses {AppConsts.APP_NAME}) ke Email dan Whatsapp Anda.</Text>
            <Text mt={12} textAlign={"center"}>Klik sini untuk Akses ke Member Area:</Text>
            <Flex mt={1}>
                <Spacer />
                <Button onClick={() => { window.open(AppConsts.Logos_APPURL, "_blank") }}>Akses Member Area</Button>
                <Spacer />
            </Flex>

            <Text mt={12} textAlign={"center"}>Butuh Bantuan?</Text>
            <Flex mt={1}>
                <Spacer />
                <Button variant={"outline"} onClick={() => { window.open(AppConsts.UrlSupportTeam, "_blank") }}>Hubungi Team Support</Button>
                <Spacer />
            </Flex>
        </Box >
    );
};

export default CheckoutCompletePaymentStep;